export const APIEndPoints = {
    BASE_URL: "https://staging.api.cleva.online/v1/", 
};
  